"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonthCalendarUtilityClass = getMonthCalendarUtilityClass;
exports.monthCalendarClasses = void 0;
var _utils = require("@mui/utils");
function getMonthCalendarUtilityClass(slot) {
  return (0, _utils.unstable_generateUtilityClass)('MuiMonthCalendar', slot);
}
const monthCalendarClasses = exports.monthCalendarClasses = (0, _utils.unstable_generateUtilityClasses)('MuiMonthCalendar', ['root']);